
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../../../lib/supabase';

export default function PortalNav() {
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdmin = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) return;
      const { data: profile } = await supabase
        .from('profiles')
        .select('is_admin')
        .eq('id', session.user.id)
        .maybeSingle();
      if (profile?.is_admin) setIsAdmin(true);
    };
    checkAdmin();
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-8 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <div className="w-10 h-10 bg-[#0a1628] rounded-lg flex items-center justify-center">
            <span className="text-[#00e5c7] text-lg font-bold" style={{ fontFamily: "'Outfit', sans-serif" }}>
              AM
            </span>
          </div>
          <div>
            <div className="text-base font-bold text-[#0a1628]" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Alejandro Monge
            </div>
            <div className="text-[10px] text-[#5a6a7e] uppercase tracking-wider font-semibold">
              Tax Services
            </div>
          </div>
        </Link>
        <div className="flex items-center gap-4">
          {isAdmin && (
            <Link
              to="/admin"
              className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-semibold text-[#00e5c7] bg-[#00e5c7]/10 rounded-md hover:bg-[#00e5c7]/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shield-check-line text-sm"></i>
              Admin Dashboard
            </Link>
          )}
          <a
            href="tel:7147669527"
            className="text-sm text-[#5a6a7e] hover:text-[#0a1628] font-medium cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            (714) 766-9527
          </a>
          <button
            onClick={handleLogout}
            className="px-4 py-2 text-sm font-semibold text-[#0a1628] hover:text-[#00e5c7] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-logout-box-line mr-2"></i>
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}
